export const step = {
  isLogin: 'isLogin',
  isPermissionRequired: 'isPermissionRequired',
  isVerifyApproach: 'isVerifyApproach',
  isPassword: 'isPassword',
  isOTP: 'isOTP',
  isNewAccount: 'isNewAccount',
  isSetNewPassword: 'isSetNewPassword',
  isSuspendedAccount: 'isSuspendedAccount',
  isLoaderPage: 'isLoaderPage',
}

export const action = {
  signIn: 'sign-in',
  signUp: 'sign-up',
  password: 'password',
  providerSignUp: 'provider-sign-up',
}
